import { Skeleton } from "../../../components/common";

export function NotificationStatsSkeleton({ cards = 2 }: { cards?: number }) {
  return (
    <div
      className="mb-4 grid grid-cols-1 gap-4 sm:grid-cols-2"
      data-testid="notification-stats-skeleton"
    >
      {Array.from({ length: cards }, (_, index) => (
        <div
          key={index}
          className="relative rounded-lg border border-gray-200 bg-white p-4 dark:border-[#394150] dark:bg-[#212936]"
        >
          <div className="flex items-start justify-between">
            <div className="flex-1 space-y-2">
              <Skeleton className="h-7 w-16" />
              <Skeleton className="h-4 w-3/4" />
            </div>
            <Skeleton className="ml-4 h-8 w-8 rounded-lg" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function NotificationTableSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div data-testid="notification-table-skeleton">
      <div className="mb-3 flex items-center gap-3">
        <Skeleton className="h-9 w-48" />
        <Skeleton className="h-9 w-32" />
        <Skeleton className="ml-auto h-9 w-24" />
      </div>
      <div className="space-y-2 rounded-lg border border-gray-200 bg-white p-4 dark:border-[#394150] dark:bg-[#212936]">
        {Array.from({ length: rows }, (_, index) => (
          <Skeleton
            key={index}
            className="h-10 w-full"
            data-testid="notification-table-skeleton-row"
          />
        ))}
      </div>
      <div className="mt-4 flex items-center justify-center gap-2">
        <Skeleton className="h-8 w-20" />
        <Skeleton className="h-8 w-8" />
        <Skeleton className="h-8 w-8" />
        <Skeleton className="h-8 w-20" />
      </div>
    </div>
  );
}

export function NotificationFormSkeleton() {
  return (
    <div
      className="space-y-6 px-6 py-4"
      data-testid="notification-form-skeleton"
    >
      <div className="space-y-2">
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-10 w-full rounded-md" />
      </div>
      <div className="space-y-2">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-10 w-full rounded-md" />
      </div>
      <div className="space-y-2">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-[120px] w-full rounded-md" />
      </div>
      <div className="space-y-2">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-10 w-full rounded-md" />
      </div>
      <div className="flex items-center gap-3">
        <Skeleton className="h-6 w-11 rounded-full" />
        <Skeleton className="h-4 w-16" />
      </div>
    </div>
  );
}
